import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

function setFont () {
  var html = document.documentElement
  var k = 375
  var size = html.clientWidth / k * 20
  html.style.fontSize = size > 25.6 ? '25.6px' : size + 'px'
}
setFont()
setTimeout(function () {
  setFont()
}, 300)
document.addEventListener('DOMContentLoaded', setFont, false)
window.addEventListener('resize', setFont, false)
window.addEventListener('load', setFont, false)

const routes = [
  {path: '/', redirect: '/index'},
  { path: '/index', name: 'index', component: () => import('./Index')},
  { path: '/matrix', name: 'matrix', component: () => import('./Matrix')},
  { path: '/news', name: 'news', component: () =>  import('./News') }
]

const router = new VueRouter({
  routes 
})

Vue.use(VueRouter)
Vue.use(VueLazyload)

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')